import styled from "styled-components";

export const EventosStyle = styled.div`
    
`;